const CONS = {
    HIDDEN_CLASS: 'odf-hidden',
    PREFERRED_JS_CLASS: '.legend_preferred_seat',
    EXTRA_JS_CLASS: '.legend_extra_leg_room_seat',
    STANDARD_JS_CLASS: '.legend_standard_seat',
    SMART_JS_CLASS: '.legend_cheapest_seat',
    PREFERRED_TYPE: 'preferred',
    EXTRA_TYPE: 'extra',
    SMART_TYPE: 'smart',
    STANDARD_TYPE: 'standard',
};

module.exports = {
    updateSeatTypes: function(seatTypeAvailability) {
        this.$el.find(CONS.PREFERRED_JS_CLASS).toggleClass(CONS.HIDDEN_CLASS, !seatTypeAvailability[CONS.PREFERRED_TYPE]);
        this.$el.find(CONS.EXTRA_JS_CLASS).toggleClass(CONS.HIDDEN_CLASS, !seatTypeAvailability[CONS.EXTRA_TYPE]);
        this.$el.find(CONS.SMART_JS_CLASS).toggleClass(CONS.HIDDEN_CLASS, !seatTypeAvailability[CONS.SMART_TYPE]);
        this.$el.find(CONS.STANDARD_JS_CLASS).toggleClass(CONS.HIDDEN_CLASS, !seatTypeAvailability[CONS.STANDARD_TYPE]);
    },
};
